import type { RouteContext } from "@/routes/__root";
import { redirect } from "@tanstack/react-router";

export const isAuthenticated = ({ context }: { context: RouteContext }) => {
  if (!context.auth.isAuthenticated) {
    throw redirect({
      to: "/login",
      search: { redirect: location.href, message: "Please sign in to continue.", messageType: "info" },
    });
  }
};
